import { ChangeDetectionStrategy, Component, Optional, ViewEncapsulation } from "@angular/core";
import { NzTbodyComponent } from "ng-zorro-antd/table";
import { UiTableStyleService } from "@webapp/ui/table/services/table-style.service";

@Component({
  selector: "tbody",
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  templateUrl: "tbody.component.html",
})
export class UiTbodyComponent extends NzTbodyComponent {
  constructor(@Optional() uiTableStyleService: UiTableStyleService) {
    super(uiTableStyleService);
  }
}
